export function setStorage(key, val) {
  return localStorage.setItem(key, val)
}

export function getStorage(key) {
  return localStorage.getItem(key)
}

export function removeStorage(key) {
  return localStorage.removeItem(key)
}
